import {
    ChangeDetectorRef,
    Component, DoCheck, ElementRef, EventEmitter, HostBinding, HostListener, Input, Output,
    OnDestroy,
} from '@angular/core';

import {GlobalAlertService} from "../../global-alert.service";
import {ButtonCode, GlobalPopup} from '../../global-popup';
import {TranslateService} from "../../../../shared/services/translate/translate.service";
import {Subscription} from "rxjs";
import {GlobalModel} from "../../../../shared/services/state/global.model";
import {AuthorizationService} from "../../../../shared/services/authorization/authorization.service";
import {AbstractBasePopupComponent} from '../abstract-base-popup.component';
import {TooltipService} from "../../../../shared/services/tooltip/tooltip.service";
import {LoggerService} from "../../../../shared/services/logger/logger.service";
import {GlobalPopupControlProgramEditService} from "./global-popup-control-program-edit.service";
import {
    ITimeControl,
    IControlProgram,
    IControlProgramList,
    IProgramType
} from "./global-popup-control-program-edit.interface";
import {AppSettings} from "../../../../app.settings";
import * as dayjs from "dayjs";
import {take} from "rxjs/operators";
import {PopupDisplayMode} from "../default-popup-wrapper/default-popup-wrapper.interface";
import {kelvinToHex} from "../../../../shared/utils/convert-kelvin";
import {TableOptionsSet} from "../../../../shared/components/table/tableColumnSelector/table-options";
import Utils from "../../../../shared/utils/utils";
import {LumiSelectOption} from "../../../../shared/components/commonUI/select/lumi-select/lumi-select.interface";
import {GlobalEvent} from "../../../../shared/interfaces/global-event";
import {IColorBar, IDataPoint} from "../../../../shared/components/commonUI/colorBar/color-bar.interface";
import * as moment from "moment/moment";


declare let google:any|google.maps.event;


@Component ({
    selector: 'global-popup-control-program-edit-component',
    templateUrl: 'global-popup-control-program-edit.component.html',
    styleUrls: ['global-popup-control-program-edit.component.scss']
})

export class GlobalPopupControlProgramEditComponent extends AbstractBasePopupComponent implements DoCheck, OnDestroy {
    private subscriptions: Subscription[] = [];
    @Input() @HostBinding('class.control-v2-embedded-editor') embedded = false;
    @Input() programId: number | null = null;
    @Input() copyOnOpen = false;
    @Output() saved = new EventEmitter<void>();
    @Output() dirtyChange = new EventEmitter<boolean>(true);
    private originalProgram = '';
    private embeddedDirty = false;
    @Input() currentActiveFilterQuery = '';
    public googleChart:any = null;
    private googleChartOptions:any;
    public showList = false;

    public POPUP_DISPLAY_MODE = PopupDisplayMode;

    public _mobileMode = false;
    public _tabletMode = false;
    public _laptopMode = false;
    public availableColorPallet: string[] = AppSettings.CONTROL_PROGRAM_COLOR_PICKER_DEFAULT_OPTIONS;
    public disableAddProgramButton = false;
    public isAddingNewProgram = false;
    public isLoadingControlProgram = false;
    private isSaving = false;
    public activeControlProgram:IControlProgram = null;
    public controlProgramsList:IControlProgramList[] = [];
    public availableProgramTypes:IProgramType[] = [];
    public hasFormError = false;
    private googleChartData:any = null;
    private currentDragPointId:number = null;
    private isDragging = false;
    private hasChanged = false;
    private defaultChartWidth = 740;
    public showColorTemperature = false;
    public showColorHex = false;
    public defaultColorTemperature = 2500;
    public defaultColorHex = '#FF9F46';
    public minColorTemperature = 1200;
    public maxColorTemperature = 4000;
    public saveSuccess = false;
    private hasReachedZero = false;
    public openTimeTypeControlId:number = null;

    public constructor(protected cd:ChangeDetectorRef, protected elementRef:ElementRef, private controlProgramService:GlobalPopupControlProgramEditService, protected globalAlertService:GlobalAlertService, protected ts:TranslateService, private model:GlobalModel, public auth:AuthorizationService, protected tooltipService:TooltipService, protected logger:LoggerService) {
        super(cd, globalAlertService, elementRef, ts, tooltipService, logger);
    }

    ngOnInit(){
        if (!this.embedded) {
            this.getControlProgramLists();
        }
        this.getAvailableProgramTypes();


        google.charts.load('current', {'packages':['corechart', 'charteditor']});
        this.googleChartOptions = {
            vAxis: {title: 'Percentage', viewWindow: {min: 0, max: 100}},
            hAxis: {title: '', format: 'HH:mm'},
            legend: {position: 'none'},
            tooltip: {isHtml: true},
            width: this.defaultChartWidth,
            height: 390,
            chartArea: {
                right:20,
                width: '90%',
                height: '80%'
            }
        };
        this.subscriptions.push(this.model.mobileMode.subscribe((value: boolean) => {
            // Don't forget to unsubscribe
            this._mobileMode = value;
            this.checkToDisableNavigation()
        }));
        this.subscriptions.push(this.model.tabletMode.subscribe((value: boolean) => {
            // Don't forget to unsubscribe
            this._tabletMode = value;
            this.checkToDisableNavigation()
        }));
        this.subscriptions.push(this.model.laptopMode.subscribe((value: boolean) => {
            // Don't forget to unsubscribe
            this._laptopMode = value;
            this.checkToDisableNavigation()
        }));
    }

    @HostListener('window:resize')
    public onWindowResize(): void {
        if (this.googleChart) {
            this.drawChart();
        }
    }

    ngDoCheck(): void {
        if (this.embedded && this.activeControlProgram) {
            const dirty = this.programSnapshot() !== this.originalProgram;
            if (dirty !== this.embeddedDirty) {
                this.embeddedDirty = dirty;
                this.dirtyChange.emit(dirty);
            }
        }
    }

    private programSnapshot(): string {
        return JSON.stringify(this.activeControlProgram, (key, value) =>
            ['timestamp', 'controlId', 'locked', 'dateSunInfo', 'createdAt', 'updatedAt'].includes(key) ? undefined : value);
    }

    @HostListener('document:click', ['$event'])
    onClickOutside(event: MouseEvent) {
        const clickedElement = event.target as HTMLElement;
        if (!clickedElement.closest('.smart-selection-dropdown')) {
            this.closeAllOptionDropdowns();
        }
        if (!clickedElement.closest('.time-type-dropdown')) {
            this.openTimeTypeControlId = null;
        }
    }

    private checkToDisableNavigation():void{
        if(!this._mobileMode && !this._tabletMode && !this._tabletMode){
            this.showList = false;
            this.cd.detectChanges()
        }
    }
    public toggleArticleNavigation(forceClose = false, preventDefault = false){
        if((this._mobileMode || this._tabletMode || this._laptopMode) && (!preventDefault)){
            if(!forceClose){
                this.showList = !this.showList;
            } else {
                this.showList = false;
            }
        }
    }

    public updateTimeControlColorTemp(timeControl:ITimeControl,kelvinValue:number){
        timeControl.colorTemp = Number(kelvinValue);
        if(kelvinValue != 0){
            timeControl.colorHex = kelvinToHex(kelvinValue);
        }
        else {
            timeControl.colorHex = '';
        }
    }

    public updateTimeControlColorHex(timeControl:ITimeControl,hexValue:string){
        timeControl.colorHex = hexValue;
    }

    private resetTimeControlColorTemp():void{
        this.activeControlProgram.timeControls.map(_x => {
            this.updateTimeControlColorTemp(_x, this.defaultColorTemperature)
        })
    }

    private resetTimeControlColorHex():void{
        this.activeControlProgram.timeControls.map(_x => {
            this.updateTimeControlColorHex(_x, this.defaultColorHex)
        })
    }

    public addProgram(){
        this.closeAllOptionDropdowns();
        this.isAddingNewProgram = true;
        this.showColorTemperature = false;
        this.hasFormError = true;
        this.activeControlProgram = {
            id: null,
            name: '',
            description: '',
            color: this.availableColorPallet[Math.floor(Math.random()*this.availableColorPallet.length)],
            astroEnabled: false,
            programTypeId:Number(this.getAvailableProgramTypesForSelect()[0].id),
            sunsetOffset: '0',
            sunriseOffset: '0',
            dateSunInfo:null,
            adminOnly:false,
            timeControls:[this.getDefaultTimeControl(true)],
            updatedAt: '',
            createdAt: ''
        }
        this.setProgramType(this.getAvailableProgramTypesForSelect()[0]?.id);
        this.setSelected(null);
        this.cd.detectChanges();
        this.loadGoogleChartData();
    }

    public getSelectedProgramType(programTypeId:number): LumiSelectOption[] {
        return this.availableProgramTypes.filter(option => option.id === programTypeId);
    }

    public getAvailableProgramTypesForSelect():LumiSelectOption[]{
        if(this.availableProgramTypes && this.availableProgramTypes.length > 0){
            return this.availableProgramTypes;
        } else {
            return [{
                id:1,
                name:'Standaard',
                code:'standard',
            }];
        }
    }

    public getSelectedProgramTypeCode():string{
        return this.getAvailableProgramTypesForSelect().find(_x => {
            return _x.id == this.activeControlProgram.programTypeId;
        }).code || 'standard';
    }

    public setProgramType(programTypeId: string|number): void {
        this.activeControlProgram.programTypeId = Number(programTypeId);
        switch(this.getSelectedProgramTypeCode()){
            case 'tunable_white': //Color temp
                this.showColorTemperature = true;
                this.showColorHex = false;
               // this.resetTimeControlColorTemp();
                break;
            case 'rgb': //RGB
                this.showColorTemperature = false;
                this.showColorHex = true;
                //this.resetTimeControlColorHex();
                break;
            default: //Default
                this.showColorTemperature = false;
                this.showColorHex = false;
                break;
        }
    }

    public convertToUtc(dateTime:string):string{
        if(!this.hasTime(dateTime)){
            dateTime = dateTime+' 00:00:00';
        }
        moment.locale(TranslateService.LOCALE);
        // const [datePart, timePart] = dateTime.split(" ");
        // const [year, month, day] = datePart.split("-").map(Number);
        // const [hour, minute, second] = timePart.split(":").map(Number);
        const utcDate = moment(dateTime, 'YYYY-M-DD hh:mm:ss');
        return utcDate.toString();
    }

    private hasTime(value: string): boolean {
        return /^\d{4}-\d{2}-\d{2}\s+\d{2}:\d{2}:\d{2}$/.test(value);
    }

    private showSaveSuccess():void{
        this.saveSuccess = true;
        setTimeout(()=>{
            this.saveSuccess = false;
            this.cd.detectChanges();
        }, 4000)
    }


    public saveProgram(){
        if(this.activeControlProgram.name != '' && !this.isSaving){
            this.isSaving = true;
            this.activeControlProgram.timeControls.map(_x => {
                if(this.showColorTemperature) {
                    const temperature = Number((_x.colorTemp && _x.colorTemp != 0) ? _x.colorTemp : this.defaultColorTemperature)
                    this.updateTimeControlColorTemp(_x, temperature)
                } else if(this.showColorHex) {
                    const colorHex = String((_x.colorHex && _x.colorHex != '') ? _x.colorHex : this.defaultColorHex)
                    this.updateTimeControlColorTemp(_x, 0)
                    this.updateTimeControlColorHex(_x, colorHex)
                } else {
                    this.updateTimeControlColorTemp(_x, 0)
                }

                //9999 or higher will be send as null when saved. Id is needed for dragging in google charts but when send to backend it will try to save at that id which does not exist.
                if(_x.id >= 9999){
                    _x.id = null;
                }
            })
            this.subscriptions.push(this.controlProgramService.saveControlProgram(this.activeControlProgram).subscribe((formPostResult) => {
                const controlProgram:IControlProgram = (formPostResult as any).controlList;
                if (this.embedded) {
                    this.isSaving = false;
                    this.saved.emit();
                    return;
                }
                this.getControlProgram(controlProgram.id);


                if(this.activeControlProgram.id === null){
                    this.controlProgramsList.unshift({
                        id: controlProgram.id,
                        name: controlProgram.name,
                        description: controlProgram.description,
                        color: controlProgram.color,
                        programTypeId: controlProgram.programTypeId,
                        isHidden:false,
                        isSelected:true,
                        showOptionsDropdown:false,
                    })
                    this.setSelected(controlProgram.id)
                    this.activeControlProgram = controlProgram;
                } else {
                    const currentListControlProgram = this.controlProgramsList.find(_x => {return _x.id == this.activeControlProgram.id;})
                    currentListControlProgram.name = controlProgram.name;
                    currentListControlProgram.description = controlProgram.description;
                    currentListControlProgram.color = controlProgram.color;
                    currentListControlProgram.programTypeId = controlProgram.programTypeId;
                }

                this.showSaveSuccess();
                this.cd.detectChanges();
                this.isSaving = false;
            }));
            this.hasChanged = true;
        }
    }

    public programTypeTranslation(programTypeId):string{
        return this.getSelectedProgramType(programTypeId)[0]?.name
    }

    public toggleOptionsDropdown(item:IControlProgramList,$event: MouseEvent):void{
        // Prevent default event
        this.preventDefault($event);
        // Close all other dropdowns
        this.closeAllOtherOptionDropdowns(item);
        this.getControlProgram(item.id);
        // Toggle dropdown
        item.showOptionsDropdown = !item.showOptionsDropdown;
    }

    public preventDefault($event: MouseEvent): void {
        Utils.preventDefault($event);
    }

    public closeAllOptionDropdowns():void{
        this.controlProgramsList.forEach(_x => {
            _x.showOptionsDropdown = false;
        })
    }
    public closeAllOtherOptionDropdowns(item:IControlProgramList):void{
        this.controlProgramsList.forEach(_x => {
            if(_x !== item){
                _x.showOptionsDropdown = false;
            }
        })
    }


    public copyProgram($event?:MouseEvent):void{
        this.closeAllOptionDropdowns();
        if ($event) {
            this.preventDefault($event);
        }
        this.isAddingNewProgram = true;
        this.hasFormError = true;
        this.activeControlProgram.name = '';
        this.activeControlProgram.id = null;
        this.activeControlProgram.timeControls.map(_x => {
            _x.id = Math.floor(Math.random() * 99999) + 9999;
        })
        this.setSelected(null);
        this.cd.detectChanges();
        this.loadGoogleChartData();
    }


    public deleteActiveControlProgram():void{
        this.globalAlertService.addPopup(this.ts.translate("control-program.remove-program-title"), this.ts.translate("control-program.remove-program-label"),
            [{label:this.ts.translate("Annuleren"), code:ButtonCode.ANNULEREN, isPrimary:true},
                {label:this.ts.translate("Verwijderen"), code:ButtonCode.DELETE,
                    callback:() => {
                        this.subscriptions.push(this.controlProgramService.deleteControlProgram(this.activeControlProgram.id).pipe(take(1)).subscribe((data) => {
                            this.controlProgramsList.splice(this.controlProgramsList.map(function(e) { return e.id; }).indexOf(this.activeControlProgram.id),1);
                            if(this.controlProgramsList.length > 0){
                                this.getControlProgram(this.controlProgramsList[0].id);
                            } else {
                                this.addProgram();
                            }
                            this.hasChanged = true;
                        }));
                    },
                    isPrimary:false}
            ], () => {})
    }



    public checkForError(){
        this.hasFormError = this.activeControlProgram.name == '';
        this.cd.detectChanges()
    }

    private getControlProgramLists():void{
        this.subscriptions.push(this.controlProgramService.getControlProgramsList().subscribe((formPostResult) => {
            this.controlProgramsList = formPostResult as any;
            this.cd.detectChanges()

            if(this.controlProgramsList.length > 0){
                if(this.globalPopup.data && this.globalPopup.data.selectedScheme && this.globalPopup.data.selectedScheme !== -1){
                    this.getControlProgram(this.globalPopup.data.selectedScheme);
                } else {
                    this.getControlProgram(this.controlProgramsList[0].id);
                }
            } else {
                this.addProgram();
            }
        }));
    }

    private getAvailableProgramTypes():void{
        this.subscriptions.push(this.controlProgramService.getAvailableProgramTypes().subscribe((formPostResult) => {
            const returnProgramTypes = formPostResult as any;
            //Pull the name through the translator
            returnProgramTypes.map(_x => {
                _x.name = this.ts.translate(_x.name);
            })
            this.availableProgramTypes = returnProgramTypes;
            if (this.embedded) {
                if (this.programId) {
                    this.getControlProgram(this.programId);
                } else {
                    this.addProgram();
                }
            }
            this.cd.detectChanges()
        }));
    }

    public getControlProgram(controlProgramId:number):void{
        this.closeAllOptionDropdowns();
        this.setSelected(controlProgramId);
        this.hasReachedZero = false;
        this.subscriptions.push(this.controlProgramService.getControlProgram(controlProgramId).subscribe((formGetResult) => {
            this.activeControlProgram = (formGetResult as any).controlList;
            this.setProgramType(this.activeControlProgram.programTypeId);

            this.activeControlProgram.timeControls.forEach((timeControl) => {
                timeControl.timestamp = this.computeTimeControlTimestamp(timeControl);
            });

            //Check if there is an item with 1970-01-01 12:00:00. If so, lock the first match. Otherwise, add it.
            const startingTimeControls:ITimeControl[] = this.activeControlProgram.timeControls.filter(_x => {
                return _x.timestamp.format("YYYY-MM-DD HH:mm:ss") === "1970-01-01 12:00:00";
            });
            if(startingTimeControls.length > 0){
                startingTimeControls[0].locked = true;
            } else {
                //Add locked one to the time controls
                this.activeControlProgram.timeControls.push({
                    id:null,
                    time:'12:00:00',
                    dimLevel:100,
                    colorHex: '',
                    colorTemp: 0,
                    timestamp:dayjs('1970-01-01 12:00:00', 'YYYY-MM-DD HH:mm:ss'),
                    locked:true,
                })
            }

            this.addFrontEndIdToControls();
            this.cd.detectChanges()
            this.loadGoogleChartData();
            this.checkForError();
            if (this.embedded) {
                this.originalProgram = this.programSnapshot();
                if (this.copyOnOpen) {
                    this.copyOnOpen = false;
                    this.copyProgram();
                }
            }
        }));
    }

    private addFrontEndIdToControls():void{
        const list = this.activeControlProgram.timeControls;
        if (!list || !list.length) {
            return;
        }

        // Find the first locked item, if any
        const lockedIndex = list.findIndex(_x => _x && _x.locked === true);

        if (lockedIndex === -1) {
            // No locked item, keep existing order and numbering
            list.forEach((_x, index) => {
                _x.controlId = index + 1;
            });
            // Ensure list is ordered by controlId
            list.sort((a, b) => {
                const aId = a?.controlId ?? 0;
                const bId = b?.controlId ?? 0;
                return aId - bId;
            });
            return;
        }

        // Assign controlId 1 to the locked item (the first locked if there are multiple)
        list[lockedIndex].controlId = 1;

        // Now assign the rest in their current order, skipping the locked one
        let currentId = 2;
        for (let i = 0; i < list.length; i++) {
            if (i === lockedIndex) continue;
            list[i].controlId = currentId;
            currentId++;
        }
        // Finally, order the timeControls by controlId (as requested for line 377)
        list.sort((a, b) => {
            const aId = a?.controlId ?? 0;
            const bId = b?.controlId ?? 0;
            return aId - bId;
        });
    }

    private getDefaultTimeControl(locked:boolean):ITimeControl{
        return {
            id:Math.floor(Math.random() * 99999) + 9999,
            controlId:1,
            time: '12:00',
            timestamp: dayjs('1970-01-01 12:00:00', 'YYYY-MM-DD HH:mm:ss'),
            dimLevel: 100,
            locked: locked,
            timeType: 'fixed',
            offsetMinutes: null,
        }
    }

    public addTimeControl(){
        const previousTimeControl = this.activeControlProgram.timeControls.length ? this.activeControlProgram.timeControls[this.activeControlProgram.timeControls.length-1] : null;

        //Set random number from 9999 or higher to make sure google charts can drag because it needs an id.
        let timeControlToAdd: ITimeControl = this.getDefaultTimeControl(true);
        if(previousTimeControl !== null){
            let timestampToUse = dayjs(previousTimeControl.timestamp).add(1, 'hour')

            if(previousTimeControl.dimLevel == 0){
                this.hasReachedZero = true;
            } else if(previousTimeControl.dimLevel == 100){
                this.hasReachedZero = false;
            }

            if(timestampToUse.format('DHHmm') > '21200'){
                timestampToUse = previousTimeControl.timestamp;
            }
            timeControlToAdd = {
                id:Math.floor(Math.random() * 99999) + 9999,
                controlId:previousTimeControl.controlId+1,
                time: timestampToUse.format('HH:mm'),
                timestamp: timestampToUse,
                dimLevel: this.hasReachedZero ? Math.min(previousTimeControl.dimLevel + 10, 100) : Math.max(previousTimeControl.dimLevel - 10, 0),
                locked: false,
                colorHex: this.showColorHex ? this.defaultColorHex : '',
                colorTemp: this.showColorTemperature ? this.defaultColorTemperature : '0',
            }
        }
        this.activeControlProgram.timeControls.push(timeControlToAdd)
        this.loadGoogleChartData();
    }

    public changeTimeControl(){
        this.loadGoogleChartData();
    }


    public setTimeControlTimeType(timeControl:ITimeControl, timeType:string|number):void{
        timeControl.timeType = String(timeType);
        if(timeControl.timeType === 'fixed'){
            //Switching back to a fixed time: restore a concrete time from the current (sun-based) timestamp
            if(!timeControl.time){
                timeControl.time = timeControl.timestamp ? timeControl.timestamp.format('HH:mm:ss') : '12:00:00';
            }
            timeControl.offsetMinutes = null;
        } else {
            if(timeControl.offsetMinutes === null || typeof timeControl.offsetMinutes === 'undefined' || timeControl.offsetMinutes < 0){
                timeControl.offsetMinutes = 0;
            }
            //Sunrise/sunset is relative to the sun time, so the fixed start time is cleared
            timeControl.time = null;
        }
        timeControl.timestamp = this.computeTimeControlTimestamp(timeControl);
    }

    public changeTimeControlOffset(timeControl:ITimeControl):void{
        if(timeControl.offsetMinutes !== null && typeof timeControl.offsetMinutes !== 'undefined' && timeControl.offsetMinutes < 0){
            timeControl.offsetMinutes = 0;
        }
        timeControl.timestamp = this.computeTimeControlTimestamp(timeControl);
        this.loadGoogleChartData();
    }

    //Builds the chart timestamp for a time control. For sunrise/sunset types it derives the
    //time from the program's sun info (+ offset); otherwise it uses the fixed time.
    private computeTimeControlTimestamp(timeControl:ITimeControl):dayjs.Dayjs{
        let baseTime:string = timeControl.time;
        if((timeControl.timeType === 'sunrise' || timeControl.timeType === 'sunset') && this.activeControlProgram && this.activeControlProgram.dateSunInfo){
            const sunData = timeControl.timeType === 'sunrise' ? this.activeControlProgram.dateSunInfo.sunrise : this.activeControlProgram.dateSunInfo.sunset;
            if(sunData && sunData.now){
                let sunTimestamp = dayjs('1970-01-01 '+sunData.now);
                if(timeControl.offsetMinutes){
                    sunTimestamp = sunTimestamp.add(Number(timeControl.offsetMinutes), 'minute');
                }
                baseTime = sunTimestamp.format('HH:mm:ss');
            }
        }
        if(!baseTime){
            baseTime = timeControl.timestamp ? timeControl.timestamp.format('HH:mm:ss') : '12:00:00';
        }
        //Chart runs from noon to noon; times before noon belong to the next day
        if(baseTime < '12:00:00'){
            return dayjs('1970-01-02 '+baseTime, 'YYYY-MM-DD HH:mm:ss');
        }
        return dayjs('1970-01-01 '+baseTime, 'YYYY-MM-DD HH:mm:ss');
    }

    public getTimeTypeIcon(timeType:string):string{
        switch(timeType){
            case 'sunrise': return 'wb_sunny';
            case 'sunset': return 'bedtime';
            default: return 'schedule';
        }
    }

    public toggleTimeTypeDropdown(timeControl:ITimeControl, $event:MouseEvent):void{
        this.preventDefault($event);
        if(!this.canEditControlProgram()){
            return;
        }
        this.openTimeTypeControlId = this.openTimeTypeControlId === timeControl.controlId ? null : timeControl.controlId;
    }

    public selectTimeType(timeControl:ITimeControl, timeType:string, $event:MouseEvent):void{
        this.preventDefault($event);
        this.setTimeControlTimeType(timeControl, timeType);
        this.openTimeTypeControlId = null;
        this.loadGoogleChartData();
    }

    public removeTimeControl(timeControl:ITimeControl){
        if(!timeControl.locked){
            this.activeControlProgram.timeControls.splice(this.activeControlProgram.timeControls.findIndex(_x => {
                return _x.controlId === timeControl.controlId;
            }), 1)
            this.cd.detectChanges();
            this.loadGoogleChartData();
        }

    }

    public selectColor(type:'default'|'timeControl', id?:number):void {
        if(type === 'default'){
            this.activeControlProgram.color = this.activeControlProgram.color.toUpperCase()
        } else if(type === 'timeControl'){
            this.getTimeControl(id).colorHex = this.getTimeControl(id).colorHex.toUpperCase()
        }
    }

    public doSearch():void {
        this.controlProgramsList.map(_x => {
            if(this.currentActiveFilterQuery == ''){
                _x.isHidden = false;
            } else {
                _x.isHidden = !(_x.name.toLowerCase().includes(this.currentActiveFilterQuery.toLowerCase()) || this.programTypeTranslation(_x.programTypeId).toLowerCase().includes(this.currentActiveFilterQuery.toLowerCase())) || _x.isSelected;
            }
        })
        this.cd.detectChanges();
    }

    public hasSearchQuery():boolean {
        return !(this.currentActiveFilterQuery == '' || this.currentActiveFilterQuery == null || typeof this.currentActiveFilterQuery == 'undefined');
    }

    public clearSearchQuery():void {
        this.currentActiveFilterQuery = ''
        this.doSearch()
    }

    public canEditControlProgram():boolean{
        const isAdmin = true;
        if(isAdmin){
            return true;
        } else { return !this.activeControlProgram.adminOnly; }
    }

    public changeAstroOffset(event:any){
        this.activeControlProgram.astroEnabled = (<HTMLInputElement>event.target).checked;
    }

    public changeTimeControlTime(event:any, id:number){
        if(event && dayjs(event).isValid()){
            event = dayjs(event);
            event = event.set('year', 1970).set('month', 0).set('date', 1);
            if (event < dayjs('1970-01-01 12:00:00', 'YYYY-MM-DD HH:mm:ss')) {
                event = event.set('date', 2);
            }
            this.getTimeControl(id).time = dayjs(event).format('HH:mm:ss');
            this.getTimeControl(id).timestamp = dayjs(event, 'YYYY-MM-DD HH:mm:ss');
        }
        this.loadGoogleChartData();
    }

    get dataPointsForColorBar() : IColorBar[] {
        const data: IColorBar[] = [];
        this.activeControlProgram.timeControls.map(_x => {
            data.push({
                colorHex: _x.colorHex,
                colorTemp: _x.colorTemp,
                timestamp: _x.timestamp
            })
        })
        return data;
    }

    get chartArea():any{
        const cli = this.googleChart.getChartLayoutInterface();
        return cli.getChartAreaBoundingBox();
    }

    private getTimeControl(id:number):ITimeControl{
        return this.activeControlProgram.timeControls.find(_x => {
            return _x.controlId == id;
        })
    }

    private mouseMoveScript(event:any):void{
        if(this.currentDragPointId !== null && this.isDragging){
            const time = event.offsetX;
            const valTime = this.googleChart.getChartLayoutInterface().getHAxisValue(time);
            const percentage = event.offsetY;
            const valPercentage = this.googleChart.getChartLayoutInterface().getVAxisValue(percentage);

            let newValuePercentage:number = Math.ceil(valPercentage/5)*5;
            if(valPercentage < 0){
                newValuePercentage = 0;
            } else if(valPercentage > 100){
                newValuePercentage = 100;
            }

            const newValueTime:string = dayjs(valTime).format('HH:mm')
            const day = dayjs(valTime).get('date');
            let hour = dayjs(valTime).get('hour');
            let forcedTimeSet = false;

            if(day == 1){
                if(newValueTime < '12:00'){
                    hour = 12;
                    forcedTimeSet = true;
                }
            } else if(day == 2){
                if(newValueTime > '12:00'){
                    hour = 12;
                    forcedTimeSet = true;
                }
            }

            if(this.currentDragPointId == 0){
                if(this.activeControlProgram.timeControls.length > 0){
                    this.activeControlProgram.timeControls[0].dimLevel = newValuePercentage;
                }
            } else {
                const timeControlElement = this.activeControlProgram.timeControls.find(_x => {return _x.id == this.currentDragPointId});
                let minuteToUse = Math.ceil(dayjs(valTime).get('minute')/30)*30;
                if(forcedTimeSet){
                    minuteToUse = 0;
                }

                if (minuteToUse == 60) {
                    minuteToUse = 0;
                    hour++;
                }
                timeControlElement.dimLevel = newValuePercentage;
                timeControlElement.timestamp = dayjs('1970-01-0'+day+' '+hour+':'+minuteToUse+':00', 'YYYY-MM-DD HH:mm:ss');
                timeControlElement.time = hour.toString().padStart(2, '0')+':'+minuteToUse.toString().padStart(2, '0')+':00';
            }
            this.loadGoogleChartData();
        }
    }

    private addDragPoint(event){
        const pointId = this.googleChartData?.eg[event.row]?.pointId;
        if(pointId !== null){
            this.currentDragPointId = pointId;
        }
    }

    private removeDragPoint():void{
        this.currentDragPointId = null;
        this.cd.detectChanges();
    }

    private mouseDownScript(event:Event):void{
        this.isDragging = true;
    }

    private mouseUpScript(event:Event):void{
        this.isDragging = false;
        this.removeDragPoint();
    }

    private loadGoogleChartData(){
        if(this.googleChart === null){
            this.googleChart = new google.visualization.AreaChart(this.elementRef.nativeElement.querySelector('#graph'));

            //Events
            google.visualization.events.addListener(this.googleChart, 'onmouseover', (event) => {this.addDragPoint(event);});
            google.visualization.events.addListener(this.googleChart, 'onmouseout', () => {this.removeDragPoint();});
            this.elementRef.nativeElement.querySelector('#graph').addEventListener('mousemove', (e: Event) => {this.mouseMoveScript(e)});
            this.elementRef.nativeElement.querySelector('#graph').addEventListener('mousedown', (e: Event) => {this.mouseDownScript(e)});
            this.elementRef.nativeElement.querySelector('#graph').addEventListener('mouseup', (e: Event) => {this.mouseUpScript(e)});
        }
        //New data, clear chart and add data if applicable

        const chartData:any = [];

        this.activeControlProgram.timeControls.forEach((timeControl) => {
            chartData.push(timeControl);

        });

        chartData.sort(function(a,b){
            return a.timestamp.toDate() - b.timestamp.toDate();
        });

        const _googleChartData:any = [];

        for (let i = 0; i < chartData.length; i++) {
            const point = chartData[i];
            _googleChartData.push({
                pointId: point.locked ? null : point.id,
                c:[
                    {v: point.timestamp.toDate(), f: point.timestamp.format('YYYY-MM-DD HH:mm:ss')},
                    {v: point.dimLevel, f: point.dimLevel},
                    {v: point.locked ? 'point { visible:false }' : 'point { visible:true }'},
                    {v: this.googleChartHoverText(point)},
                ]
            });

            const nextPoint = chartData[i + 1];
            if (typeof nextPoint !== 'undefined') {
                _googleChartData.push({
                    pointId: null,
                    c:[
                        {v: nextPoint.timestamp.toDate(), f: nextPoint.timestamp.format('YYYY-MM-DD HH:mm:ss')},
                        {v: point.dimLevel, f: point.dimLevel},
                        {v: 'point { visible:false }'},
                        {v: this.googleChartHoverText(nextPoint)},
                    ]
                });
            }
        }

        const end = { ...chartData[0] };
        end.timestamp =  dayjs('1970-01-02 12:00:00', 'YYYY-MM-DD HH:mm:ss');
        end.dimLevel = chartData[chartData.length - 1].dimLevel;
        end.id = chartData[chartData.length - 1].id;
        _googleChartData.push({
            pointId: null,
            c:[
                {v: end.timestamp.toDate(), f: end.timestamp.format('HH:mm')},
                {v: end.dimLevel, f: end.dimLevel},
                {v: 'point { visible:false }'},
                {v: this.googleChartHoverText(end)},
            ]
        });

        this.googleChartData = new google.visualization.DataTable({
            cols: [
                {id: 'time', label: this.ts.translate('control-program.column-time'), type: 'date'},
                {id: 'level', label: this.ts.translate('control-program.column-percentage'), type: 'number'},
                {type: 'string', role: 'style'},
                {type: 'string', role: 'tooltip', 'p': {'html': true}}
            ],
            rows: _googleChartData
        });
        this.googleChart.clearChart();
        this.drawChart();
    }

    private googleChartHoverText(data:ITimeControl):string{
        let colorInfo = '';
        if(data.colorHex && data.colorHex != ''){
            colorInfo = ` | <span style="border-left:4px solid ${data.colorHex};border-radius:3px;padding-left:3px;margin-left:2px;text-transform:uppercase;">${data.colorTemp != '0' ? data.colorTemp+'K' : data.colorHex}</span>`;
        }
        return '<span style="font-weight:bold;">'+data.timestamp.format('HH:mm')+'</span>: '+data.dimLevel+'%'+colorInfo;
    }

    private drawChart(){
        const containerWidth:number = this.elementRef.nativeElement.querySelector('#graph')?.closest('.graph-parent').getBoundingClientRect().width - 50;
        if(this.googleChart !== null){
            if (this.embedded) {
                this.googleChartOptions.width = Math.max(1, containerWidth + 50);
                this.googleChartOptions.colors = [getComputedStyle(this.elementRef.nativeElement).getPropertyValue('--selection-blue').trim() || '#2962ff'];
                this.googleChartOptions.backgroundColor = 'transparent';
            } else if(containerWidth < this.defaultChartWidth){
                this.googleChartOptions.width = containerWidth;
            } else {
                this.googleChartOptions.width = this.defaultChartWidth;
            }
        }
        this.googleChart.draw(this.googleChartData, this.googleChartOptions)
    }

    private setSelected(controlProgramId:number):void{
        if(controlProgramId !== null){
            this.isAddingNewProgram = false;
        }
        if(this.controlProgramsList && this.controlProgramsList.length > 0){
            //Set the selected item to false
            this.controlProgramsList.filter(_x => {return _x.isSelected}).map(_x => {_x.isSelected = false});
            //Set current item selected
            this.controlProgramsList.filter(_x => {return _x.id == controlProgramId}).map(_x => {_x.isSelected = true});
        }
    }

    public convertStringDateToFormat(date:string|number,format:string):string{
        return dayjs(date).locale(this.ts.getLanguage()).format(format);
    }

    handlePopupAction(event: MouseEvent, alert: GlobalPopup, button: any): void {
        //Hide alert and perform callback of button
        this.onPopupAction.emit({event:event, alert:alert, button:button, data:{dataChanged:this.hasChanged}});
    }

    public closePopup(event:any):void
    {
        //When the moments have changed, show a are-your-sure-popup
        this.doDefaultCloseHandling(event,this.isAddingNewProgram);
    }

    ngOnDestroy(){
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
        this.googleChart?.clearChart();
        if (this.googleChart) {
            google.visualization.events.removeAllListeners(this.googleChart);
        }
    }
}
